import { Component, OnInit } from '@angular/core';
import { DataGridTemplate } from '../../../../../shared/data-grid/data-grid.template';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { FormDialogTemplate } from '../../../../../shared/form-dialog/form-dialog.template';
import { CtwrComponentService, CtwrComponentCategoryService, CtwrProcessService, CtwrItemService } from '../../../ctwr.service';

@Component({
  selector: 'app-component-category',
  templateUrl: './component-category.component.html',
  styleUrls: ['./component-category.component.scss']
})
export class ComponentCategoryComponent extends DataGridTemplate implements OnInit {
  editForm: FormGroup;
  editRowIndex: number;
  formDialog: FormDialogTemplate;
  processControls: any[] = [];

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly componenCategoryService: CtwrComponentCategoryService,
    private readonly componentService: CtwrComponentService,
    private readonly processService: CtwrProcessService,
    private readonly itemService: CtwrItemService,

  ) { super(); }

  ngOnInit() {
    this.formDialog = new FormDialogTemplate();
    this.modal = true;
    this.formDialog.setHeight(640);
    this.formDialog.largeForm = true;
    this.formDialog.cancel = () => this.closeForm();
    this.sortable = true;
    this.filterable = 'menu';
    this.gridState.sort = [{ dir: 'asc', field: 'Name' }];

    this.editForm = this.getEditForm();
    this.formDialog.notificationLabel = { flag: 'info', state: 'edit', value: '*Editing this record may impact current, future, and past requests.' };

    this.componentService.read();
    this.itemService.read();
    this.processService.read('')
      .then(data => {
        this.formDialog.initilize("Category", this.editForm, this.formDialogTabs);
        return data;
      });
  }


  create(parentEditDataItem: any): void {
    this.formDialog.isNew = true;
    this.editDataItem = { PTE: DefaultPte };
    this.formDialog.next(this.editDataItem);
    this.editForm.get('Name').enable();
  }


  read(opts: any): Promise<any> {
    return opts.force ?
      this.componenCategoryService.read('') :
      Promise.resolve(this.componenCategoryService.value);
  }


  edit(dataItem: any): void {
    this.formDialog.isNew = false;
    this.componenCategoryService.read(`/${dataItem.Id}`)
      .then(x => {
        this.formDialog.next(x);
      });
    this.editForm.get('Name').disable();
  }



  save(dataItem: any, isNew: boolean): Promise<any> {
    this.closeForm();
    const _path: string = isNew ? '' : (`/${dataItem.Id}`);
    return this.componenCategoryService.save(dataItem, isNew, _path, false)
  }


  delete(dataItem: any): Promise<any> {
    return this.componenCategoryService.remove(`/${dataItem.Id}`, false)
  }

  getEditForm(): FormGroup {
    return this.formBuilder.group({
      Id: [],
      Name: ['', Validators.compose([Validators.required, Validators.maxLength(65)])],
      ProcessIds: [],
      ComponentIds: [],
      PTE: [DefaultPte, Validators.required]
    })
  }

  closeForm() {
    this.editForm = this.getEditForm();
    this.formDialog.editForm = this.editForm;
  }


  handlePteEdit = ({ sender, rowIndex, dataItem }) => {
    this.pteEditForm.reset(dataItem);
    sender.closeRow(this.editRowIndex);
    this.editRowIndex = rowIndex;
    sender.editRow(rowIndex, this.pteEditForm);
  }


  handlePteSave = ({ sender, rowIndex }) => {
    sender.closeRow(rowIndex);
    const ctrl = this.editForm.get('ProcessPTEs');
    const value = ctrl.value;
    value[rowIndex].PTE = this.pteEditForm.value.PTE;
    ctrl.setValue(value);
  }

  pteEditForm = this.formBuilder.group({ PTE: [Validators.required] });

  columns: any[] = [
    {
      field: 'Name',
      title: 'Name',
    },
    {
      field: 'ItemNames',
      title: 'Item Names'
    },
    {
      field: 'ProcessNames',
      title: 'Processes'
    }
  ]

  formControls = [
    {
      type: 'text',
      title: 'Name',
      name: 'Name',
      invalidText: 'Invalid Input. Name must be between 1 and 65 characters.',
      stretch: true,
    },
    {
      type: "multiselect",
      title: "Item Names",
      name: "ComponentIds",
      textField: "Name",
      valueField: "Id",
      service: this.componentService,
      stretch: true
    },
    {
      type: "multiselect",
      title: "Processes",
      name: "ProcessIds",
      textField: "Name",
      valueField: "Id",
      service: this.processService,
      stretch: true
    },
    {
      type: 'radiogroup',
      inline: true,
      title: 'PTE',
      name: 'PTE',
      options: [
        {
          value: 'PTE1',
          label: 'PTE1',
        },
        {
          value: 'PTE2',
          label: 'PTE2',
        },
      ]
    },

  ]

  formDialogTabs = [
    {
      title: "Categories",
      selected: true,
      formControls: this.formControls
    },
  ]
}

const DefaultPte: string = "PTE1";
